module.exports = __webpack_public_path__ + "static/sleep-country-logo-dd71a04b9d5c657837cf2adb2170894e.png";